import EntafarmaLogo from '@/assets/logos/partners/entafarma.svg?react';
import RezusLogo from '@/assets/logos/partners/rezus.svg?react';
import TelAvivCapitalLogo from '@/assets/logos/partners/tel-aviv-capital.svg?react';
import TelomeraLogo from '@/assets/logos/partners/telomera.svg?react';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';

export function PartnersSection() {
  return (
    <Section containerClassName="lg:pb-39 pb-20">
      <Heading as="h2" className="text-secondary mb-3.75 lg:mb-16.25">
        Our Partners
      </Heading>

      <div className="lg:bg-muted flex gap-3 py-3.5 lg:mx-auto lg:max-w-231.25 lg:gap-17.5 lg:rounded-[12.5rem] lg:px-18.5 lg:py-6.5">
        <RezusLogo className="w-[22%]" />
        <TelomeraLogo className="w-[32%]" />
        <EntafarmaLogo className="w-[16%]" />
        <TelAvivCapitalLogo className="w-[30%]" />
      </div>
    </Section>
  );
}
